import { render, staticRenderFns } from "./billList.vue?vue&type=template&id=3716cd30&scoped=true"
import script from "./billList.vue?vue&type=script&lang=ts"
export * from "./billList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716cd30",
  null
  
)

export default component.exports